import key from './key.js'
import {pub, sub} from './pubsub.js'
import sess from './session'
import tab from './tab'
import term from './terminal'
import ui from './ui'
import win from './win'
import ws from './ws'
import { runtime } from "../utils/utils-js"
const running = runtime

let sshKnowHostsBasePath = "/ssh/known_hosts"

let os = runtime.os
let arch = runtime.arch
let browser = runtime.browser
let platform = runtime.platform
let isElectron = runtime.isElectron
let supportWebGL2 = runtime.supportWebGL2

// console.log("os:", os)
// console.log("arch:", arch)
// console.log("browser:", browser)
// console.log("isElectron:", isElectron)
// console.log("supportWebGL2:", supportWebGL2)

export default {
    pub,
    sub,
    tab: tab,
    tabNext: tab.next,
    tabPrev: tab.prev,
    tabDestroy: tab.destroy,
    tabDestroyAddCallback: tab.destroyAddCallback,
    tabDestroyCurrent: tab.destroyCurrent,
    tabDestroyCurrentAddCallback: tab.destroyCurrentAddCallback,
    tabDup: tab.dup,
    tabDupAddCallback: tab.dupAddCallback,
    tabCurrentReconnect: tab.currentReconnect,
    tabCurrentReconnectAddCallback: tab.currentReconnectAddCallback,
    tabCurrentChange: tab.currentChange,
    tabCurrentChangeAddCallback: tab.currentChangeAddCallback,
    tabNewTab: tab.newTab,
    tabNewTabAddCallback: tab.newTabAddCallback,
    term: term,
    termFocusCurrent: term.focusCurrent,
    termFocusCurrentAddCallback: term.focusCurrentAddCallback,
    sess: sess,
    // setupShortcuts,
    ui: ui,
    showSessionInfo: ui.showSessionInfo,
    showSessionAddCallback: ui.showSessionAddCallback,
    showSessionList: ui.showSessionList,
    showSessionListAddCallback: ui.showSessionListAddCallback,
    hideTabsTopMenu: ui.hideTabsTopMenu,
    hideTabsTopMenuAddCallback: ui.hideTabsTopMenuAddCallback,
    win: win,
    winResize: win.resize,
    // winResizeAddCallback: win.resizeAddCallback,
    ws: ws,
    wsBaseUrl: ws.baseUrl,
    key: key,   // 密钥管理相关
    sshKnowHostsBasePath,

    running,
    // win32/darwin/linux/unix/android/iphone/ipad/ipod/unknown
    os,
    // x64/ia32/arm/unknown
    arch,
    // edge/safari/chrome/firefox/opera/unknown
    browser,
    // true/false
    isElectron,
    // true/false
    supportWebGL2,
    // electron/browser
    platform,
}
